var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SphereBufferGeometry, } from "three";
import { Meshes } from "./Meshes";
var Spheres = /** @class */ (function (_super) {
    __extends(Spheres, _super);
    function Spheres(params, $paramObjArray) {
        var _this = _super.call(this, params) || this;
        // ------------------------------ Geometry
        _this.geometry = new SphereBufferGeometry(100);
        // ------------------------------ Meshes
        _this._createMeshes($paramObjArray);
        return _this;
    }
    return Spheres;
}(Meshes));
export { Spheres };
